(function($) {

    /**
     * The way this works is to hide the field with the name of the input this matches (ie those with class 'msx-duration-picker'). It then creates two
     * visible fileds (one for hours and one for minutes) and populates the hidden field whenever the these change (either with minutes or hours depending on the
     * options on the hidden filed). This way a minutes (or hours) field can be replaced just by adding a CSS class with no other changes.
     *
     * This is also extremely flexible in the future if someone wishes to change all duration fields to include days, or use a popup or whatever.
     *
     * @param options - Optional override of the default options (see below)
     */
	$.fn.msxidurationpicker = function(options) {
		// build main options before element iteration
		var opts = $.extend(true, {}, $.fn.msxidurationpicker.defaults, options);

        function isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }
            return true;
        }

        // init async to avoid unresponsive script warnings in IE8 (when there are lots on the page)
		return this.eachAsync({
            loop: function() {
                var $this = $(this);

                // build element specific options
                var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;

                if($this.is(".form-text")) {
                    // Process Non-editable field
                    var $cellDiv = $this;

                    // set duration based on value in html div
                    var min = (parseInt($cellDiv.html()) || 0);
                    $cellDiv.html(parseInt(min / 60)+translate('h')+' '+(min % 60)+translate('m'));
                }
                else {
                    var $parentDiv = $this.parent();
                    // Process Editable field
                    var $hiddenCell = $this;
                    // make the edit cell invivible
                    $hiddenCell.prop('required',false).hide();

                    // create two new cells
                    var $hours = $('<input type="text" value="0" class="msx-duration-picker msx-duration-picker-hours">');
                    var $mins = $('<input type="text" value="0" class="msx-duration-picker msx-duration-picker-minutes">');

                    $hours.attr('title', $hiddenCell.attr('title'));
                    $mins.attr('title', $hiddenCell.attr('title'));
                    if($hiddenCell.is('.error')) {
                        $hours.addClass('error');
                        $mins.addClass('error');
                    }

                    if($hiddenCell.prop('disabled')) {
                        $hours.prop('disabled', true);
                        $mins.prop('disabled', true);
                    }

                    if($hiddenCell.prop('readonly')) {
                        $hours.prop('readonly', true);
                        $mins.prop('readonly', true);
                    }

                    $parentDiv.append($hours);$parentDiv.append(' '+translate('hours')+' ');
                    $parentDiv.append($mins);$parentDiv.append(' '+translate('mins')+' ');

                    // set duration based on value in now hidden field
                    var min = (parseInt($hiddenCell.val()) || '');
                    $hours.val(min === '' ? '' : parseInt(min / 60));
                    $mins.val(min === '' ? '' : min % 60);

                    $parentDiv.keypress(isNumber);

                    $parentDiv.keyup(function () {
                        // do the maths to set the value
                        if ($hours.val() === '' && $mins.val() === '') {
                            $hiddenCell.val('');
                        }
                        else {
                            var minEntered = ((parseInt($hours.val()) || 0) * 60) + (parseInt($mins.val()) || 0);
                            $hiddenCell.val(minEntered);
                        }
                    });
                }
            }
        });
	};

	$.fn.msxidurationpicker.defaults = {
        showPeriodLabels: false,
        defaultDuration: ''
    };

})(jQuery);
